import { useMemo } from 'react';

import { HistoricalVisit, HistoricalVisitSimple } from '@dreryk/egabinet-visit-frontend-api';

import { SidePanelListItem } from '@dreryk/react-components';

import { VisitDiagnoses } from '~libs.shared.visit';

import { useVisitFormCopyAvailable } from '../../visit/form/VisitFormSynchronization.hooks';

import { createHistoricalVisitItems, createHistoricalVisitsListItems } from './historicalVisits.utils';

export const useHistoricalVisitsListItems = (
   historicalVisits: HistoricalVisitSimple[] | undefined,
   onItemClick: (visitId: number) => void
): SidePanelListItem[] => {
   return useMemo(() => createHistoricalVisitsListItems(historicalVisits || [], onItemClick), [
      historicalVisits,
      onItemClick,
   ]);
};

export const useHistoricalVisitItems = (
   historicalVisit: HistoricalVisit | undefined,
   targetVisitId: number,
   patientId: number,
   visitDiagnoses: VisitDiagnoses
): SidePanelListItem[] | undefined => {
   const visitFormCopyAvailable = useVisitFormCopyAvailable();
   return useMemo(
      () =>
         createHistoricalVisitItems(historicalVisit, visitFormCopyAvailable, targetVisitId, patientId, visitDiagnoses),
      [historicalVisit, visitFormCopyAvailable, targetVisitId, patientId, visitDiagnoses]
   );
};
